<script setup lang="ts">
const { backgroundColor = 'transparent', applyPadding = false, breakOut = false } = defineProps<{
  /**
   * The background color of the container.
   */
  backgroundColor?: ContentColor

  /**
   * Apply padding to the inner content?
   */
  applyPadding?: boolean

  /**
   * Break out this component from the grid to full width.
   * If false (the default), the container will be full width and have a max-width.
   */
  breakOut?: boolean
}>()

defineOptions({
  inheritAttrs: false,
})

// For now we asume that primar and secondary are dark colors, and white and muted are light colors.
const textColorClass = computed(() => {
  switch (backgroundColor) {
    case ContentColor.White:
    case ContentColor.Muted:
    case ContentColor.Transparent:
      return 'text-black'
    default:
      return 'text-white'
  }
})

const backgroundColorClass = computed(() => {
  switch (backgroundColor) {
    case null:
    case undefined:
      return ''
    case ContentColor.White:
      return 'bg-white'
    case ContentColor.Black:
      return 'bg-black'
    case ContentColor.ThemeText: // should not be used as background
      return 'bg-theme-text'
    case ContentColor.Transparent:
      return 'bg-transparent'
    case ContentColor.Muted:
      return 'bg-muted-100'
    default:
      return `bg-${backgroundColor}-500`
  }
})

const contentBlockPadding = inject<string>('contentBlockPadding', 'p-8 md:py-10')

const { cardRadiusClass } = useThemeClasses()

</script>

<template>
  <div
    :class="{
      'mx-auto max-w-[calc(theme(maxWidth.7xl)-2rem)] md:max-w-7xl': !breakOut,
      '-mx-4': breakOut,
    }"
  >
    <div
      v-bind="$attrs"
      class="relative dark:text-white"
      :class="{
        // Inner padding
        [contentBlockPadding]: applyPadding,
        // Card radius - only when not breaking out
        [cardRadiusClass]: !breakOut,
        // Text color
        [textColorClass]: true,
        // Background colors
        //[`bg-${backgroundColor}${backgroundColor === 'white' ? '' : '-500'}`]: true,
        [backgroundColorClass]: true,
        'dark:bg-muted-900': backgroundColor !== 'transparent',
      }"
    >
      <slot />
    </div>
  </div>
</template>
